import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { InputAdornment, TextField, FormControl, IconButton } from "@material-ui/core"
import { useFormik } from "formik"
import * as yup from "yup"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import SubjectSearchIcon from "../../icons/SubjectSearchIcon"
import { setFilterData } from "../../../actions/filterActions"
import { updateQueryString } from "../../../utils"
import { history } from "../../../helpers/history"

const useStyles = makeStyles((theme) => ({
	textField: {
		width: "152px",
		"& .MuiInput-underline": {
			paddingLeft: "12px",
			...theme.typography.body2,
			border: `1px solid ${theme.palette.grey["D400"]}`,
			borderRadius: 3,
		},
		"& fieldset > legend": {
			float: "none",
		},
		"& input[type='text']:focus": {
			boxShadow: "none",
		},
		"& .MuiInput-underline:after": {
			borderBottom: "none",
		},
		"& .MuiInput-underline:before": {
			borderBottom: "none",
		},
		"& .MuiInput-underline:hover": {
			borderBottom: "none",
		},
	},
	inputFormControl: {
		padding: "12px 0 24px",
	},
	subjectSearchForm: {
		margin: "-4px 0 0 20px",
	},
}))

const SearchInSubject = (props) => {
	const theme = useTheme()
	const classes = useStyles(theme)
	const [t] = useTranslation("global")
	const dispatch = useDispatch()
	const subjectTextData = useSelector((state) => state.filter?.subject)
	const [subjectText, setSubjectText] = useState(subjectTextData)

	const subjectSearchFormSchema = yup.object({
		subjectText: yup.string().trim(),
	})

	const handleSubmit = (data) => {
		const subjectText = data?.subjectText?.trim()

		if (subjectText) {
			//TODO: Dispatch event to call the file search api

			setSubjectText((prev) => subjectText)
			const updatedQueryString = updateQueryString({ subject: subjectText })
			const url = `${window.location.pathname}?${updatedQueryString}`
			history.push(url)
			console.log(updatedQueryString)
			dispatch(setFilterData({ subject: subjectText }))
		}
	}

	const handleClearSubTxt = () => {
		subjectSearchForm?.resetForm()
		dispatch(setFilterData({ subject: "" }))
	}

	const handleEnterSubmit = (e) => {
		if (e.key === "Enter" && e.keyCode === 13) {
			e.preventDefault()

			if (e.target.value?.length > 0) {
				dispatch(setFilterData({ subject: e.target.value }))
			}
		}
	}

	const subjectSearchForm = useFormik({
		initialValues: {
			subjectText: subjectTextData || "",
		},
		validationSchema: subjectSearchFormSchema,
		onSubmit: handleSubmit,
	})

	return (
		<form
			className={classes.subjectSearchForm}
			noValidate
			autoComplete="off"
			id="subject-search"
			onSubmit={subjectSearchForm.handleSubmit}
		>
			<FormControl>
				<TextField
					name="subjectText"
					placeholder={t("subjectSearch.placeholderTxt")}
					disableRipple
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								{subjectSearchForm.values.subjectText && (
									<IconButton onClick={handleClearSubTxt}>
										<SubjectSearchIcon />
									</IconButton>
								)}
							</InputAdornment>
						),
					}}
					style={subjectSearchForm.values.subjectText ? { width: 335 } : { width: 152 }}
					variant="standard"
					className={classes.textField}
					value={subjectSearchForm.values.subjectText}
					onKeyDown={handleEnterSubmit}
					onChange={subjectSearchForm.handleChange}
					onBlur={subjectSearchForm.handleBlur}
					error={subjectSearchForm.touched.subjectText && Boolean(subjectSearchForm.errors.subjectText)}
					helperText={subjectSearchForm.touched.subjectText && subjectSearchForm.errors.subjectText}
				/>
			</FormControl>
		</form>
	)
}

export default SearchInSubject
